export default {
  name: 'bridge-author',
  cdn: {
    edge: 'https://d1h1778jwn2brc.cloudfront.net',
    staging: 'https://d2wzd4gs88w14e.cloudfront.net',
    production: 'https://d3fuoknb3jgind.cloudfront.net',
  },
  pathPatterns: [/^\/author\b/],
  stylesheets: [
    'stylesheets_main_external_css',

    // application and module specific styles need to be loaded after framework
    // styles for now because we can't rely on proper specificity right now and
    // external component styles will clash with legacy styles
    'stylesheets_application_css',
    'stylesheets_author_css',
    'stylesheets_author_author_modules_css',
    'stylesheets_author_author_sass_modules_css',
  ],
  scripts: ['javascripts_author_js'],
  disabledNavPaths: [
    /^\/author\/courses\/\d+\/slide/,
    /^\/author\/courses\/\d+\/preview/,
    /^\/author\/programs\/\d+\/edit/,
  ],
};



// WEBPACK FOOTER //
// ./jsapp/author/learn-runtime.js